import { BrowserRouter, useLocation } from 'react-router-dom';
import './App.css';
import './assets/GlobalStyle.scss'
import Routes from './routes/routes';
import { useEffect, useState } from 'react';
import { ContextProvider } from 'context/context';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App">
      <div>
        <ContextProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes />
          </BrowserRouter>
        </ContextProvider>
      </div>
    </div>
  );
}

export default App;
